import React from 'react'
import { Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router'

import styles from './style.module.scss'

const ModellingTopBarBtns = () => {
  const { push } = useHistory()

  return (
    <>
      <div className={`${styles.logo} mr-4`}>
        <div className={styles.logoContainer}>
          <img src="/resources/images/logos/logo-inverse.png" alt="logo" />
        </div>
      </div>
      <Button className="mr-4 ant-btn-primary" onClick={() => push('/overview')}>
        <FormattedMessage id="menu.overview" />
        <span className={`icmn icmn-home ${styles.overviewIcon}`} />
      </Button>
    </>
  )
}

export default ModellingTopBarBtns
